import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/paymentMethods/importer/paymentMethodsImporterActions'

export default importerReducers(actions)
